import React, { Component } from 'react'
import { painel, fieldset, Item, Input } from 'scorpion-core';
import EditorSeletor from '../../editor/SeletorUidCustomForm'
import Tabela from './Tabela'

import EditorCodigo from '../../editor/EditorCodigo'

import { Field } from 'redux-form';
function componentRelEspelho(comp, dados) {
    return ("")
}

function component(item, propsview) {
    // console.log('propsview', propsview);
    let funcFiltro = null;
    try {
        funcFiltro = new Function("return " + item.filtro)();
    } catch (error) {
    }
    return (<Item key={item.sha} style={{ flex: 1 }}>
        <Tabela label={item.label}
            item={item} propsview={propsview} funcFiltro={funcFiltro} />
        {/* <Field name={item.field} label={item.label}
            item={item} propsview={propsview} component={Tabela} /> */}
    </Item>)
}

const modelo = {
    typeComponente: "ListCustomFormFiltros",
    field: "itens",
    label: "Lista de Itens Custom",
    nomeItem: "Item",
    componentes: [
        { field: "uid", label: "UID", desativado: true, typeComponente: "Input" },
        { field: "titulo", label: "Titulo", desativado: true, typeComponente: "Input", },
    ],
    customFormUid: "",
    filtro: `function atendeFiltro(obj){ return true; }`,


}
const comp = {
    typeComponente: "ListCustomFormFiltros",
    configView: {
        nome: "List Custom Form Filtros",
        modelo,
        editores: {
            customFormUid: EditorSeletor,
            filtro: EditorCodigo,
        },
    },
    componentRelEspelho,
    component
}



export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/ListCustomFormFiltros/index.js